import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { BooleanField, DateField, Labeled, ReferenceField, Show, SimpleShowLayout, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { specialistRequests } from "api/specialistApi";
import { SectionTitle } from "features/SectionTitle";

const ShowHealthcareCourses = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Show
      title="Детайли на курс за здравни грижи"
      actions={<BackButtonToolbar />}
    >
      <SectionTitle
        title="Основна информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на български">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на английски">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Описание на български">
              <TextField source="descriptionBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Описание на английски">
              <TextField source="descriptionEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Специалност здравни грижи">
              <ReferenceField
                source="speciality"
                reference={specialistRequests.getHealthcareSpecialitySelect()}
              >
                <TextField source="nameBg" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Срада">
              <ReferenceField
                source="buildingId"
                reference={administrationRequests.getBuildingsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Дни продължителност">
              <TextField source="durationInDays" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Кредити">
              <TextField source="credits" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Година">
              <TextField source="year" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Начална дата на курса - по желание">
              <BooleanField source="hasDesiredDate" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="От дата">
              <DateField
                source="fromDate"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="До дата">
              <DateField
                source="toDate"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Минимум участници">
              <TextField source="minimumParticipants" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowHealthcareCourses;
